import axiosApi from '@apis/axiosApi'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'

const KT = '/nhan-su/khen-thuong'
const KL = '/nhan-su/ky-luat'

// Lọc khen thưởng
export function locKhenThuong(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get(`${KT}/loc-danh-sach-khen-thuong`, { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy khen thưởng nhân viên
export function layKhenThuongNhanVien(userId: number) {
  try {
    return axiosApi.get(`${KT}/nhan-vien/${userId}/khen-thuong`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Tạo khen thưởng nhân viên
export function taoKhenThuongNhanVien(userId: number, params: any) {
  try {
    return axiosApi.post(`${KT}/tao-khen-thuong-nhan-vien?userId=${userId}`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Cập nhật khen thưởng nhân viên
export function capNhatKhenThuongNhanVien(rewardId: number, params: any) {
  try {
    return axiosApi.put(`${KT}/khen-thuong/${rewardId}/cap-nhat-khen-thuong`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Xóa khen thưởng nhân viên
export function xoaKhenThuongNhanVien(rewardId: number) {
  try {
    return axiosApi.delete(`${KT}/khen-thuong/${rewardId}/xoa-khen-thuong`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lọc kỷ luật
export function locKyLuat(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get(`${KL}/loc-danh-sach-ky-luat`, { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy kỷ luật nhân viên
export function layKyLuatNhanVien(userId: number) {
  try {
    return axiosApi.get(`${KL}/nhan-vien/${userId}/ky-luat`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Tạo kỷ luật nhân viên
export function taoKyLuatNhanVien(userId: number, params: any) {
  try {
    return axiosApi.post(`${KL}/tao-ky-luat-nhan-vien?userId=${userId}`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Cập nhật kỷ luật nhân viên
export function capNhatKyLuatNhanVien(disciplineId: number, params: any) {
  try {
    return axiosApi.put(`${KL}/ky-luat/${disciplineId}/cap-nhat-ky-luat`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Xóa kỷ luật nhân viên
export function xoaKyLuatNhanVien(disciplineId: number) {
  try {
    return axiosApi.delete(`${KL}/ky-luat/${disciplineId}/xoa-ky-luat`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}
